import { useAudit } from '../../api/insights';

function formatMeta(meta: unknown): string {
  if (meta == null) return '';
  try {
    return JSON.stringify(meta);
  } catch {
    return '';
  }
}

export default function Audit() {
  const { data: entries, isLoading, error } = useAudit();

  return (
    <div className="panel">
      <h2>Audit log</h2>
      <p className="muted">Most recent significant actions across the system.</p>

      {isLoading && <p className="muted">Loading…</p>}
      {error && <p className="error">Could not load audit log: {String(error)}</p>}

      {entries && (
        <table className="table">
          <thead>
            <tr>
              <th>When</th>
              <th>Actor</th>
              <th>Action</th>
              <th>Entity</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            {entries.map((e) => (
              <tr key={e.id}>
                <td className="muted small">{new Date(e.createdAt).toLocaleString()}</td>
                <td>{e.actor?.displayName ?? '—'}</td>
                <td>
                  <code className="code">{e.action}</code>
                </td>
                <td className="muted small">
                  {e.entityType}:{e.entityId.slice(0, 8)}
                </td>
                <td className="muted small">{formatMeta(e.metadata)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
